(function () {
  var COLORS = ['#e8629a', '#6fb5e0', '#f08a3c', '#ffffff', '#92bc88'];
  var BASE = { disableForReducedMotion: true, zIndex: 1000 };

  var config = window.lakorAdventConfettiConfig || {};
  var USE_CONFETTI = config.type === 'confetti' || config.type === 'both';
  var USE_PIPES = config.type === 'pipes' || config.type === 'both';
  var FACTOR = { light: 0.3, medium: 0.6, lots: 1 }[config.amount] || 0.6;

  // The finale fires ~10x the particles of a single burst, so it gets extra damping on top of the amount setting.
  var FINALE_DAMP = 0.5;

  function amount(n, damp) {
    return Math.max(1, Math.round(n * FACTOR * (damp || 1)));
  }

  var PIPE_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 284 125.3" width="284" height="125.3"><path d="M281.6,11C280.7,7.3 277.6,5.6 276.2,4.2C274.7,2.8 274.4,2.7 273,2.6C271.5,2.5 268.7,3 267.4,3.4C266,3.8 265.8,4.3 265,5.2C264.1,6.1 263.3,8.3 262.5,9C261.8,9.7 265.3,10.4 260.5,9.4C255.8,8.5 241.3,4.4 233.9,3.2C226.4,2 223.4,1.7 216,2C208.7,2.3 197.3,3.7 189.7,5C182.1,6.3 176.1,8.1 170.5,9.6C164.9,11.2 158.9,13.6 156.2,14.4C153.6,15.2 155.8,15.1 154.4,14.4C153.1,13.8 150.1,11.4 148,10.6C145.9,9.8 143.9,9.1 141.8,9.6C139.7,10.2 136.6,12.4 135.2,13.8C133.8,15.3 133.7,16.8 133.4,18.2C133,19.7 133.4,21.3 133.2,22.3C132.9,23.3 133.7,23 131.8,24.3C129.8,25.5 123.4,28.7 121.3,29.7C119.3,30.6 121.1,30.6 119.3,30.1C117.6,29.6 113.3,26.9 110.7,26.7C108.1,26.4 105.5,27.3 103.7,28.5C101.9,29.6 100.8,31.7 100.1,33.7C99.3,35.7 99.6,38.9 99.3,40.3C98.9,41.7 102,39.1 97.9,41.9C93.8,44.8 80.9,52.5 74.6,57.4C68.3,62.2 62.7,68.6 60,70.8C57.3,73 58.8,71.1 58.4,70.8C57.9,70.5 57.8,71.1 57.2,69.2C56.5,67.3 55.6,62.5 54.6,59.4C53.5,56.2 52.4,52.5 50.7,50.3C49.1,48.1 47,47 44.7,46.1C42.4,45.3 39.2,45.3 37.1,45.1C35,45 33.8,45 32.1,45.3C30.3,45.6 30,45.3 26.7,46.9C23.3,48.5 14.9,53 12,55C9.1,56.9 10.2,57.5 9.2,58.4C8.3,59.2 7.4,58.8 6.4,60C5.4,61.1 3.9,63.3 3.2,65.2C2.5,67.1 1.7,69.6 2,71.4C2.3,73.2 4,73.5 4.8,75.8C5.6,78.2 5.8,81.4 7,85.4C8.2,89.4 9.7,95.2 12,99.9C14.3,104.5 18.6,110.4 20.9,113.3C23.1,116.3 23.7,116.2 25.5,117.5C27.3,118.8 29.8,120.3 31.7,121.1C33.6,122 34.8,122.4 36.9,122.7C39,123 41.9,123.2 44.1,122.9C46.4,122.6 48.2,122 50.3,120.9C52.5,119.8 52.3,121.2 57.2,116.3C62,111.4 73,98.2 79.6,91.5C86.3,84.7 91.9,80.1 97.1,75.8C102.3,71.6 107.1,67.3 110.7,66C114.3,64.7 116.4,67.9 118.5,68C120.6,68.1 121.9,67.4 123.3,66.6C124.8,65.7 125.9,64.8 127,63C128,61.1 127.4,57.6 129.6,55.4C131.7,53.1 137.2,50.8 139.8,49.5C142.4,48.3 143.3,47.5 145,47.7C146.7,48 148.3,50.3 150,50.9C151.8,51.5 153.9,51.8 155.4,51.3C157,50.9 158.2,50.1 159.4,48.1C160.7,46.2 161.4,41.6 162.7,39.7C164,37.8 164.7,38.1 167.3,36.9C169.8,35.7 174.5,33.6 177.9,32.3C181.3,31 183.4,30.4 187.9,29.3C192.5,28.1 200.6,26.3 205.2,25.5C209.8,24.6 211.2,24.5 215.6,24.3C220,24.1 226,23.8 231.5,24.3C236.9,24.8 244.1,26.3 248.5,27.3C252.9,28.3 256,29.5 257.7,30.3C259.5,31.1 258.6,31 258.9,32.1C259.2,33.2 258.9,35.6 259.5,36.9C260.1,38.2 261.4,39.2 262.5,39.9C263.7,40.6 265.4,41 266.6,41.1C267.7,41.2 268.1,41.3 269.6,40.7C271,40.1 273.2,39.9 275.2,37.5C277.2,35.1 280.5,30.7 281.6,26.3C282.7,21.9 282.5,14.7 281.6,11Z" fill="#1a1a1a"/><g fill="#e0457b"><circle cx="32.9" cy="48.3" r="2.4"/><circle cx="38" cy="48" r="2.5"/><circle cx="43.4" cy="49" r="2.5"/><circle cx="27.7" cy="49.7" r="2.4"/><circle cx="22.9" cy="52.5" r="2.7"/><circle cx="48" cy="52.3" r="2.6"/><circle cx="33.6" cy="53.4" r="2.2"/><circle cx="39.2" cy="53.4" r="2.2"/><circle cx="17.9" cy="54.6" r="2.5"/><circle cx="27.6" cy="56.4" r="2.6"/><circle cx="43.5" cy="55.5" r="2.1"/><circle cx="13.4" cy="57.6" r="2.5"/><circle cx="36.5" cy="57.3" r="1.9"/><circle cx="47.7" cy="57.9" r="2.2"/><circle cx="21.9" cy="58.9" r="2.4"/><circle cx="32" cy="59.4" r="2.4"/><circle cx="40.5" cy="59.7" r="2.1"/><circle cx="9" cy="61.7" r="2.3"/><circle cx="17" cy="61.8" r="2.5"/><circle cx="44.4" cy="61.4" r="1.6"/><circle cx="26.5" cy="62.2" r="2.4"/><circle cx="36.4" cy="63.2" r="2.5"/><circle cx="21.4" cy="64.7" r="2.4"/><circle cx="12.1" cy="64.7" r="2.1"/><circle cx="31.2" cy="65.9" r="2.5"/><circle cx="41.7" cy="65.2" r="2.2"/><circle cx="6.1" cy="66.7" r="2.5"/><circle cx="16.3" cy="66.9" r="2.2"/><circle cx="25.6" cy="68.7" r="2.4"/><circle cx="37.5" cy="68.9" r="2.1"/><circle cx="10.5" cy="69.3" r="2"/><circle cx="19.9" cy="70.2" r="2.3"/><circle cx="32.3" cy="71.5" r="2.2"/><circle cx="5.8" cy="71.7" r="2.3"/><circle cx="14.8" cy="71.4" r="2.1"/><circle cx="27.3" cy="73.8" r="2.1"/><circle cx="10.3" cy="74.7" r="2.2"/><circle cx="21.4" cy="75.4" r="2.3"/><circle cx="15.9" cy="76.4" r="2.3"/></g></svg>';
  var PIPE_W = 140;
  var PIPE_H = 62;
  var SQUARE = 160;
  var ROTATIONS = 8;
  var NOMINAL = 26;

  var pipes = [];

  // Pre-rotated bitmap shapes (the format confetti.shapeFromText returns) drawn flat, since the
  // library's 3D tumble squashes them edge-on. Skipped when OffscreenCanvas is unavailable.
  (function loadPipes() {
    if (!USE_PIPES) return;
    var img = new Image();
    img.onload = function () {
      try {
        var m = NOMINAL / SQUARE;
        for (var i = 0; i < ROTATIONS; i++) {
          var canvas = new OffscreenCanvas(SQUARE, SQUARE);
          var ctx = canvas.getContext('2d');
          ctx.translate(SQUARE / 2, SQUARE / 2);
          ctx.rotate(i * 2 * Math.PI / ROTATIONS);
          ctx.drawImage(img, -PIPE_W / 2, -PIPE_H / 2, PIPE_W, PIPE_H);
          pipes.push({ type: 'bitmap', bitmap: canvas.transferToImageBitmap(), matrix: [m, 0, 0, m, -SQUARE * m / 2, -SQUARE * m / 2] });
        }
      } catch (e) { pipes = []; }
    };
    img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(PIPE_SVG);
  })();

  function fire(opts) {
    opts.particleCount = amount(opts.particleCount, opts.damp);
    delete opts.damp;
    confetti(Object.assign({}, BASE, opts));
  }

  function fireConfetti(opts) {
    if (USE_CONFETTI) fire(Object.assign({ colors: COLORS, shapes: ['square', 'circle'] }, opts));
  }

  function firePipes(opts) {
    if (USE_PIPES && pipes.length) fire(Object.assign({ shapes: pipes, scalar: 2.6, flat: true }, opts));
  }

  function burst(origin) {
    fireConfetti({ origin: origin, particleCount: 45, spread: 75, startVelocity: 38, ticks: 160 });
    firePipes({ origin: origin, particleCount: 8, spread: 80, startVelocity: 32, ticks: 160 });
  }

  // Side cannons only, since the content in the middle is moving up. Every confetti() call copies its
  // shapes to the worker, so pipes fire in a few waves rather than per frame.
  function finale() {
    var end = Date.now() + 900;
    var cannons = [0, 1].map(function (side) {
      return { origin: { x: side, y: 0.75 }, angle: side ? 120 : 60, spread: 55, startVelocity: 55, damp: FINALE_DAMP };
    });
    cannons.forEach(function (cannon) {
      fireConfetti(Object.assign({ particleCount: 45 }, cannon));
      firePipes(Object.assign({ particleCount: 6 }, cannon));
    });
    [300, 600, 900].forEach(function (delay) {
      setTimeout(function () {
        cannons.forEach(function (cannon) { firePipes(Object.assign({ particleCount: 2 }, cannon)); });
      }, delay);
    });
    (function frame() {
      cannons.forEach(function (cannon) { fireConfetti(Object.assign({ particleCount: 4 }, cannon)); });
      if (Date.now() < end) requestAnimationFrame(frame);
    })();
  }

  window.lakorAdventCelebrate = function (slot, count, total) {
    if (typeof confetti !== 'function' || !slot) return;
    var rect = slot.getBoundingClientRect();
    var origin = {
      x: (rect.left + rect.width / 2) / window.innerWidth,
      y: (rect.top + rect.height / 2) / window.innerHeight
    };
    if (count >= total) finale();
    else burst(origin);
  };
})();
